/**
 * 创建人：段锐
 * 时间：2019-7-01
 * 描述：指令:为携带此 SwVideo 指令的元素创建视频播放组件
 * 更新记录: 
 */
import { Directive, ElementRef, HostListener } from '@angular/core';
import { SwVideoService } from './sw-video.service';


/**
 * 为携带此 SwVideo 指令的元素创建视频播放组件
 * 
 * @example  <button type="button" class="btn btn-default" data-src="../assets/Theme/default.mp3" data-title="JJJ" SwVideo>音频播放指令</button>
 */
@Directive({
  selector: '[SwVideo]'
})
export class SwVideoDirective {

  /**
   * @ignore
   * @param el 
   * @param video 
   */
  constructor(private el: ElementRef, public video: SwVideoService) { }

  /**
   * 点击事件
   * @ignore
   * @param event 
   */
  @HostListener('click', ['$event']) onClick(event) {
    //获取到表单业务id
    let src = event.target.getAttribute("data-src");
    let title = event.target.getAttribute("data-title");
    //创建审核组件
    this.video.openVideo(title, src);
  }
}
